// extracted by mini-css-extract-plugin
export default {"fullPage":"HD5TD85RQK7ONTWgaKRs","relative":"F2cMwFUteoUh41eHetHI","wrapper":"CDsnMbZDvm5UlKBDs4Xp","content":"TsTyy8tPvIFQkDJHZ24A"};